module.exports = __webpack_public_path__ + "img/icon_youtube.b4e81a4f.svg";